import type { DatasetInvalidateTarget } from "./dataset-invalidate.type";

import {
  convertQueryInvalidate,
  type QueryInvalidateTarget,
} from "@/services/query";

export const getDatasetInvalidate = (
  datasetId: number,
  invalidate: DatasetInvalidateTarget[] = []
): QueryInvalidateTarget[] => {
  return convertQueryInvalidate({
    invalidate,
    getCustomQueryKey: (key) => {
      if (key === "list") return ["datasets", "list"];
      if (key === "item") return ["datasets", "get", datasetId];
      return undefined;
    },
  });
};
